module.exports = __webpack_public_path__ + "img/noegg.8177fc6d.jpg";